import React from 'react';
import Footer from '../components/Footer';

const ScholarshipTables = () => {
  return (
    <div className="scolarship">
      <div className="w-full p-4 space-y-8">
        {/* Header Section */}
        <div className="text-center mb-8 mt-[200px]">
          <h1 className="text-3xl font-bold text-[#23376c] mb-4">SCHOLARSHIPS AT MAYA DEVI UNIVERSITY (MDU)</h1>
          <p className="text-gray-700 max-w-4xl mx-auto">
            MDU strongly believes that monetary constraints should not become an obstacle for a student to gain access to quality education. To ensure the same, the University has a well-defined Scholarship Scheme that offers financial support to deserving students passionate about pursuing higher-education programs. This initiative by the University aims to cultivate the talent of students that might get hidden due to financial constraints. Scholarship can be availed in all the Programmes* of the University, ranging from Diploma to PG (MBA).
          </p>
        </div>

        {/* Scholarship Types */}
        <div className="bg-white shadow-lg rounded-lg p-4">
          <h2 className="text-xl font-semibold mb-4 text-[#23376c]">Types of Scholarships</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>MDUCET (MAYA DEVI UNIVERSITY COMMON ENTRANCE TEST)</li>
            <li>MERIT/ PERCENTAGE IN QUALIFYING EXAMINATION</li>
            <li>NATIONAL LEVEL TESTS/ ENTRANCE</li>
            <li>SOCIAL RESPONSIBILITY</li>
            <li>SPORTS SCHOLARSHIP</li>
          </ol>
        </div>

        {/* MDUCET Section */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-[#23376c]">MDUCET Score Based Scholarship</h2>
          <p className="text-gray-700">
            MDUCET is conducted by MDU to ascertain the credibility of the applicants about their zeal to achieve academic excellence. Students can earn up to 100% scholarship on their tuition fee based on their MDUCET Score. Students can appear for MDUCET even if they are already availing of any other scholarship offered by the University to increase their scholarship value.
          </p>
          <div className="overflow-x-auto shadow-lg rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Particulars</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold">Scholarship Offered</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {[
                  { range: "95% or above", scholarship: "100% of Tuition Fee" },
                  { range: "90-94.99%", scholarship: "50% of Tuition Fee" },
                  { range: "80-89.99%", scholarship: "30% of Tuition Fee" },
                  { range: "70-79.99%", scholarship: "20% of Tuition Fee" },
                  { range: "65-69.99%", scholarship: "10% of Tuition Fee" },
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{item.range}</td>
                    <td className="px-6 py-4 text-sm text-center">{item.scholarship}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Merit Based Section */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-[#23376c]">Merit Based Scholarship</h2>
          <p className="text-gray-700">
            Maya Devi University also offers scholarships to students based on their performance in the qualifying exam. These may include the percentage achieved in class 10 for admission to a Diploma program and the percentage achieved in the 12th board or equivalent exam for admission to an Undergraduate program. For students seeking admission to Post-graduate (MBA) courses, their aggregate marks in the Bachelor's and Master's degrees respectively will be considered for the scholarship.
          </p>
          <div className="overflow-x-auto shadow-lg rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Particulars</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold">Scholarship Offered</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {[
                  { range: "95% or above", scholarship: "100% of Tuition Fee" },
                  { range: "90-94.99%", scholarship: "50% of Tuition Fee" },
                  { range: "80-89.99%", scholarship: "30% of Tuition Fee" },
                  { range: "70-79.99%", scholarship: "20% of Tuition Fee" },
                  { range: "65-69.99%", scholarship: "10% of Tuition Fee" },
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{item.range}</td>
                    <td className="px-6 py-4 text-sm text-center">{item.scholarship}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* National Level Entrance Tests Table */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-[#23376c]">National Level Entrance Tests Scholarship</h2>
          <p className="text-gray-700">
            Maya Devi University is well aware of the hard work put in by the students to get a good ranking in the various entrance exams conducted at a National level. The following scholarships are offered to students based on their performance in such tests.
          </p>
          <div className="overflow-x-auto shadow-lg rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Course Category</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Exam Type</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold">50% Scholarship</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold">40% Scholarship</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold">30% Scholarship</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm">B.Tech.</td>
                  <td className="px-6 py-4 text-sm">JEE (Main) - Joint Entrance Examination</td>
                  <td className="px-6 py-4 text-sm">Percentile ≥ 95</td>
                  <td className="px-6 py-4 text-sm">Percentile 90-94.99</td>
                  <td className="px-6 py-4 text-sm">Percentile 85-89.99</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm">B.Pharmacy; Paramedical & applied Health Programs; Agriculture & Other Biology Based Programs</td>
                  <td className="px-6 py-4 text-sm">NEET - National Eligibility-cum-Entrance Test</td>
                  <td className="px-6 py-4 text-sm">Rank ≤ 75000</td>
                  <td className="px-6 py-4 text-sm">Rank 75001-150000</td>
                  <td className="px-6 py-4 text-sm">Rank 150001-200000</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm">MBA</td>
                  <td className="px-6 py-4 text-sm">CAT/XAT/MAT/CMAT/NMAT</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"CAT/XAT percentile ≥ 90\nMAT/CMAT percentile ≥ 90\nNMAT Score ≥ 280"}</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"CAT/XAT percentile ≥ 85\nMAT/CMAT percentile ≥ 90\nNMAT Score ≥ 260"}</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"CAT/XAT percentile ≥ 80\nMAT/CMAT percentile ≥ 80\nNMAT Score ≥ 240"}</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm">LLB; BA LLB; BBA LLB</td>
                  <td className="px-6 py-4 text-sm">CLAT - Common Law Admission Test</td>
                  <td className="px-6 py-4 text-sm">Rank ≤ 50</td>
                  <td className="px-6 py-4 text-sm">Rank 51-100</td>
                  <td className="px-6 py-4 text-sm">Rank 101-200</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm">B.A. Film & Television Studies; B.Sc. Animation; VFX & Gaming; Bachelor of Design (B.Design)</td>
                  <td className="px-6 py-4 text-sm">NIFT Entrance Exam; NID DAT; UCEED</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"NIFT Rank ≤ 1500\nNID DAT Rank ≤ 500\nUCEED Rank ≤ 1000"}</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"NIFT Rank 1501-3000\nNID DAT Rank 501-1000\nUCEED Rank 1001-2000"}</td>
                  <td className="px-6 py-4 text-sm whitespace-pre-line">{"NIFT Rank 3001-5000\nNID DAT Rank 1001-1500\nUCEED Rank 2001-3000"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Social Responsibility Table */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-[#23376c]">Social Responsibility Scholarship</h2>
          <p className="text-gray-700">
            We understand the great sacrifices that our defense personnel make to keep us and our country safe. We are also aware of the difficulties and challenges that single parents or the parents of physically handicapped children go through.
          </p>
          <div className="overflow-x-auto shadow-lg rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Category</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold">Scholarship</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Remarks</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {[
                  {
                    category: "Freedom Fighters",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Son/Daughter or Grandson/Granddaughter of Freedom Fighters (Applicable for Indian Students only)"
                  },
                  {
                    category: "Defense",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Son/Daughter of Armed/Para-Military Forces/State Police (Applicable for Indian Students only)"
                  },
                  {
                    category: "Disability",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Students having more than 50% Physical impairment (Excluding Deaf & Dumb Disability)"
                  },
                  {
                    category: "Employee",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Maya Devi University Employee enrolling any course at University, till the staff is in service"
                  },
                  {
                    category: "Employee's Sibling/Spouse",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Son/Daughter/Spouse of MDU Employee, till the staff is in service"
                  },
                  {
                    category: "Existing Student/GGI Alumni",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Students (with 60% or above) Pursuing Higher Studies"
                  },
                  {
                    category: "Alumni/Existing Student's Sibling/Spouse",
                    scholarship: "30% of Tuition Fee",
                    remarks: "Sibling/Spouse of MDU student or Alumni"
                  },
                  {
                    category: "Child of Single Mother",
                    scholarship: "30% of Tuition Fee",
                    remarks: "The child looked after by the mother alone without a husband. The woman may be divorced or whose husband/partner is dead."
                  },
                  {
                    category: "Orphan Child",
                    scholarship: "40% of Tuition Fee",
                    remarks: "Orphan is a child who's both parents are dead, or he/she is an abandoned child. The applicant is not legally adopted by any individual or couple or group."
                  }
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{item.category}</td>
                    <td className="px-6 py-4 text-sm text-center">{item.scholarship}</td>
                    <td className="px-6 py-4 text-sm">{item.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Sports Scholarship Table */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-[#23376c]">Sports Scholarship</h2>
          <p className="text-gray-700">
            Maya Devi University (MDU) believes education should promote and support talent, rather than be the cause of its suppression. It gives MDU great pleasure to offer a scholarship to talented students based on their performance in sports at national and international levels. Our action is more rewarding than support. (Any Govt. Approved/Recognised bodies)
          </p>
          <div className="overflow-x-auto shadow-lg rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold">Category</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold">Scholarship Amount</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {[
                  { category: "International Players", amount: "100% of Tuition Fee" },
                  { category: "National Medal Winners", amount: "50% of Tuition Fee" },
                  { category: "National Participation", amount: "30% of Tuition Fee" }
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{item.category}</td>
                    <td className="px-6 py-4 text-sm text-center">{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Uttrakhand Scholarship Section */}
        <div className="bg-white shadow-lg rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-4 text-[#23376c]">Scholarship For Domicile Students of Uttrakhand</h2>
          <h3 className="text-xl font-semibold mb-4 text-[#23376c]">Merit Cum Means Scholarship</h3>
          <p className="text-gray-700">
            Maya Devi University (MDU) offers the “Merit Cum Means Scholarship” exclusively for domicile students
            of Uttarakhand, as envisaged in the Uttarakhand Private Universities Act.
          </p>
        </div>

        {/* Notes Section */}
        <div className="bg-gray-50 p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4 text-[#23376c]">Scholarship Continuation Criteria</h3>
          <ul className="space-y-3 text-gray-700">
            {/* <li>• Scholarship more than 50% requires Personal Interview with Admission Committee.</li> */}
            <li>• To ensure students benefit from the scholarship throughout their academic journey, the following
              conditions must be fulfilled:</li>
            <li className="ml-4">- First-Year Scholarship
              <li>The scholarship is unconditional for the 1st year (1st & 2nd Semester).</li>
            </li>
            <li className="ml-4">- Subsequent Years
              <li>The scholarship will only continue if the student:
                <ul className="space-y-2">
                  <li>• Clears the semester/annual examination without any backlog in the 1st attempt.</li>
                  <li>• Attains a minimum of 80% attendance in each course every semester.</li>
                </ul>
              </li>
            </li>
            <li className="ml-4">- Disciplinary Rules
              <li>If a student is involved in any grave act of indiscipline and action is taken by the competent
              authority, the scholarship will be discontinued in the same semester.</li>

            </li>
          </ul>
        </div>

      </div>
      <Footer />
    </div>

  );
};

export default ScholarshipTables;